import React from 'react';
import PropTypes from 'prop-types';
import {
  SectionBackgroundImageWrapper,
  SectionBackgroundImage,
  VideoWrapper,
} from './SectionBackground.styled';
import Video from '../Video';

const SectionBackground = ({ alt, imageUrl, videoUrl, posterUrl }) => {
  return (
    <SectionBackgroundImageWrapper>
      {imageUrl && <SectionBackgroundImage alt={alt} imageUrl={imageUrl} />}
      {videoUrl && (
        <VideoWrapper alt={alt}>
          <Video src={videoUrl} poster={posterUrl} />
        </VideoWrapper>
      )}
    </SectionBackgroundImageWrapper>
  );
};

SectionBackground.propTypes = {
  alt: PropTypes.any,
  imageUrl: PropTypes.any,
  videoUrl: PropTypes.any,
  posterUrl: PropTypes.any,
};

SectionBackground.defaultProps = {
  alt: false,
  imageUrl: null,
  videoUrl: null,
  posterUrl: null,
};

export default SectionBackground;
